<template>
  <div>
    <div class="RepresentacaoConjuntoList">
      <v-card class="card-size">
        <v-card-title>
          <h2 class="headline mb-0">{{ $tc('label.grupo_rep_legal', 2) }} - {{ $tc('label.representacao_conjunto', 1) }}</h2>
        </v-card-title>

        <representacao-conjunto-list-dados
          :can-edit="canEdit"
          ref="tabelaRepresentacaoConjunto">
        </representacao-conjunto-list-dados>

        <v-card-actions v-if="canEdit">
          <v-row>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn id="btn_novo" fab @click="novo" class="v-btn__fab" color="primary" v-on="on" bottom right fixed>
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>{{$t('label.novo')}}</span>
            </v-tooltip>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import RepresentacaoConjuntoListDados from './RepresentacaoConjuntoListDados';

export default {
  name: 'RepresentacaoConjuntoList',
  data() {
    return {
    };
  },
  components: {
    RepresentacaoConjuntoListDados,
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el.startsWith('USR_CADASTRAR_GESTAO_REPRESENTACAO_CONJUNTO')).length;
    },
    canEdit() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'USR_CADASTRAR_GESTAO_REPRESENTACAO_CONJUNTO').length;
    },
  },
  methods: {
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast(this.$t('message.acesso_negado'));
      }
    },
    novo() {
      this.$router.push({ name: 'novoRepresentacaoConjunto' });
    },
  },
  mounted() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};
</script>
